import React from "react";

interface Props {
  imageSrc?: string;
  title?: string;
  quote?: string;
  author?: string;
}

export default function CareersQuote({
  imageSrc = "//cdnimg.webstaurantstore.com/uploads/design/2017/5/career-grid-quote.jpg",
  title = "You are not just a number within the company.",
  quote = "You are valued as an employee in whatever position you hold. I feel very fortunate to be a part of this team and this company as a whole that invests so much into their employees.",
  author = "Mike - Customer Solutions Specialist",
}: Props) {
  return (
    <div className="careers-quotes">
      <div className="careers-quotes-content">
        <div className="careers-quotes-review">
          <div className="careers-quotes-image">
            <img src={imageSrc} alt="" />
          </div>
          <div className="careers-quotes-text">
            <img
              src="//cdnimg.webstaurantstore.com/uploads/images/2016/10/quote-top.png"
              alt=""
              className="careers-quotes-top"
            />
            <img
              src="//cdnimg.webstaurantstore.com/uploads/images/2016/10/quote-bottom.png"
              alt=""
              className="careers-quotes-bottom"
            />
            <div className="careers-quotes-text-content">
              <h3 className="careers-quotes-text-header title">{title}</h3>
              <p className="careers-quotes-text-message text">{quote}</p>
            </div>
            <div className="careers-quotes-text-footer author">{author}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
